module.exports = __webpack_public_path__ + "img/Arrow-R.5f59557a.svg";